import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Divider, Grid, Icon, Typography } from '@mui/material';
import { PetTreatmentInformationsItem } from '../pet/PetTreatmentInformations';
import { Brightness1 } from '@mui/icons-material';
import { io } from 'socket.io-client';
import { AppointmentService } from 'services/appointment.service';
import { SocketTreatmentEvents, ThemeClassification } from 'types';
import { useInterval } from 'hooks/useInterval';
import { useTreatmentOnGoing } from 'context/TreatmentOnGoingContext';
const REFRESH_INTERVAL = 1000 * 60 * 0.1;

export const QueueInformationHeader: React.FC = () => {
  const [quantity, setQuantity] = useState<any>();
  const [ nextPet, setNextPet ] = useState<any>();
  const [classification , setClassification ] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);

  const {  petInformationsModal } = useTreatmentOnGoing();
  
  const socket = useMemo(() => {
    return io(process.env.REACT_APP_BASE_API_URL as string, { path: '/ws' });
  }, []);

  const getQueue = async () => {
    try {
      const response = await AppointmentService.inQueueLength();
      if (response.status === 200) {
        const { petsInQueue } = response.data;
        setQuantity(petsInQueue);
      }
    } catch (err) {
      if (err instanceof Error) {
        console.error(err);
      }
    }
  };


  const getNextPet = useCallback(async ()=>{
    try {
      const response = await AppointmentService.getNextPet();
      if (response.status === 200) {
        setNextPet(response.data);
      }
      const classificationT:  "EMERGENCY" | "URGENCY" | "ROUTINE_CONSULTATION" = nextPet.generalClassification;
      const generalClassification = ThemeClassification[classificationT];
      setClassification(generalClassification);

      setIsLoading(true);
    } catch (err) {
      if (err instanceof Error) {
        console.error(err);
      }
    }
  },[quantity])

  useEffect(() => {
    socket.connect();
    getQueue();
    getNextPet();
    petInformationsModal.onOpen();
    petInformationsModal.isOpen = true;
    socket.on(SocketTreatmentEvents.CONNECT, () => {
      socket.on(
        SocketTreatmentEvents.TUTOR_TREATMENT_UPDATE_VET_QUEUE,
        (data: { new: boolean }) => {
          getQueue();  
          getNextPet();  
        }
      );
    }); 
    return () => {
      socket.disconnect();
    };
  }, []);

  useInterval(() => {
    if (socket.disconnected) {
      socket.connect();
    }

    getQueue();
    getNextPet();
  }, REFRESH_INTERVAL);


  const transcribeClassification = (consultation: 'ROUTINE_CONSULTATION'| 'URGENCY' | 'EMERGENCY') => {
    switch (consultation) {
      case 'ROUTINE_CONSULTATION':
        return 'Consulta de Rotina'
      case 'URGENCY':
        return 'URGENTE'
      case 'EMERGENCY':
        return 'EMERGENCIA'
      default:
        return 'Consulta de Rotina'
    }

  }
  
  return (
    <Grid visibility={quantity > 0 ? 'visible' : 'visible'} item container xs={12} md={12} height={90} style={{ border: '10px solid #F7E6D3', borderRadius: 10,  backgroundColor: '#F7E6D3'}} >
      <Grid item container alignItems='center' xs={12} height={70} style={{backgroundColor: 'white', border: '1px solid #FBB45F', borderRadius: 10}}>
        <Brightness1 htmlColor='green' style={{marginLeft: 10}} />
        <Typography m={1} fontWeight='bold' fontSize={24}>TUTORES NA FILA: {quantity}</Typography>
        <Divider orientation='vertical'/>
        <Grid direction='column' ml={3}>
          <Grid visibility={nextPet?.pet ? 'visible' : 'hidden'} item container spacing={2} md={12}>
            <Grid item mr={2}>
              <PetTreatmentInformationsItem
                name="Próximo Tutor"
                value={nextPet?.pet?.tutor?.name.split(' ')[0]}
              />
            </Grid>
            <Grid item mr={2}>
              <PetTreatmentInformationsItem name="Plano" value={nextPet?.pet?.tutor?.company ? nextPet?.pet?.tutor?.company.companyName : 'Vet4One'} />
            </Grid>
            <Grid item mr={2}>
              <PetTreatmentInformationsItem name="Pet" value={nextPet?.pet?.name} />
            </Grid>
            <Grid item mr={2}>
              <PetTreatmentInformationsItem name="Espécie" value={nextPet?.pet?.specie} />
            </Grid>
            <Grid item mr={2}>
              <PetTreatmentInformationsItem name="Consulta" value={transcribeClassification(classification)} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
 
};